// extracted by mini-css-extract-plugin
export default {"box":"box_RdiSc","cont":"cont_jp0g1","imgs":"imgs_bO4_Y","title":"title_kC64s","con":"con_rru7F"};